import { createRouter, createWebHashHistory } from 'vue-router';
import LoginPage from '../components/LoginPage.vue';
import ForgotPassword from '../components/ForgotPasswordPage.vue';
import Redeem from '../components/RedeemPage.vue';
import Payments from '../components/PaymentsPage.vue';
import Profile from '../components/ProfilePage.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next('/redeem');
      } else {
        next();
      }
    }
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next('/redeem');
      } else {
        next();
      }
    }
  },
  {
    path: '/redeem',
    name: 'Redeem',
    component: Redeem,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/payments',
    name: 'Payments',
    component: Payments,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = localStorage.getItem('user_id') !== null;
      if (isAuthenticated) {
        next();
      } else {
        next('/');
      }
    }
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
